import DgCardtxt from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgCardtxt.install = function (Vue) {
  Vue.component(DgCardtxt.name, DgCardtxt)
}
export default DgCardtxt

export { DgCardtxt }